import { useState } from 'react';
import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

const tabs = [
  { key: 'latest', label: '最新更新' },
  { key: 'hot', label: '播放最多' },
  { key: 'top', label: '评分最高' },
];

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState('latest');

  const getSortedList = () => {
    switch (activeTab) {
      case 'hot':
        return [...animeList].sort((a, b) => b.views - a.views);
      case 'top':
        return [...animeList].sort((a, b) => b.rating - a.rating);
      default:
        return [...animeList].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());
    }
  };

  const sortedList = getSortedList().slice(0, 10);

  return (
    <section className="py-12 md:py-16 bg-background-900/50">
      <div className="container-custom">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4">
          <div>
            <h2 className="section-title">更新列表</h2>
            <p className="section-subtitle">实时追踪最新番剧动态</p>
          </div>
          <div className="flex items-center gap-1 p-1 bg-background-800 rounded-full">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/25'
                    : 'text-foreground-400 hover:text-foreground-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {sortedList.map((anime, index) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="anime-card group"
            >
              <div className="aspect-[2/3] overflow-hidden rounded-lg bg-background-800 relative">
                <img
                  src={anime.coverImage}
                  alt={anime.title}
                  title={`${anime.title} - 6080影视免费高清在线观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 w-8 h-8 flex items-center justify-center bg-primary-500 text-white text-xs font-bold rounded-br-lg">
                  {index + 1}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
                  <div className="flex items-center gap-1 text-foreground-300 text-xs">
                    <i className="ri-eye-line"></i>
                    <span>{anime.views > 10000 ? `${(anime.views / 10000).toFixed(0)}万` : anime.views}</span>
                  </div>
                </div>
              </div>
              <div className="mt-2.5">
                <h4 className="text-foreground-100 text-sm font-medium line-clamp-1 group-hover:text-primary-400 transition-colors">
                  {anime.title}
                </h4>
                <p className="text-foreground-600 text-xs mt-0.5">更新至 {anime.episodes.length} 集</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="btn-primary text-sm px-8 py-3 rounded-full inline-flex items-center gap-1"
          >
            浏览全部动漫 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}